import React from "react";
import "./Gallery.css";

const Gallery = () => {
  const images = [
    "/images/gallery-1.JPG",
    "/images/gallery-2.JPG",
    "/images/gallery-3.JPG",
    "/images/gallery-4.JPG",
    "/images/gallery-5.JPG",
    "/images/gallery-6.JPG",
    "/images/gallery-7.JPG",
    "/images/gallery-8.JPG",
    "/images/gallery-9.JPG",
    "/images/gallery-10.JPG",
    "/images/gallery-11.JPG",
    "/images/gallery-12.JPG",
    "/images/gallery-13.JPG",
    "/images/gallery-14.JPG",
    "/images/gallery-15.JPG",
    "/images/gallery-16.JPG",
    "/images/gallery-17.JPG",
  ];

  return (
    <>
      {/* Video Section */}
      <section className="video-section">
        <video src="/videos/gallery.mp4" autoPlay loop muted playsInline />
        <div className="video-caption">
<h2>Crystal Drops Experience</h2>
<p>Where design meets innovation bringing water technology to life with clarity and elegance.</p>
        </div>
      </section>

       {/* New Prestigious Project Video Section */}
         {/* New Prestigious Project Video Section */}
      <section className="project-video-section">
        <div className="project-video-wrapper">
          <video src="/videos/daf.mp4" autoPlay loop muted playsInline />
        </div>
        <div className="project-video-caption">
          <h2>Prestigious DAF System Project</h2>
          <p>
            Our landmark installation at Bangalore International Airport
            demonstrates advanced Dissolved Air Flotation technology, ensuring
            clarity, efficiency, and sustainable water management at one of
            India’s busiest aviation hubs.
          </p>
        </div>
      </section>

      {/* Masonry Image Gallery */}
      <section className="masonry-gallery">
        {images.map((src, index) => (
          <div className="masonry-item" key={index}>
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </section>
    </>
  );
};

export default Gallery;